import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'


const LoadContainer = Loadable({ loader: () => import('layers/transport/containers/LoadContainer/LoadContainer'), loading })
const HomePage      = Loadable({ loader: () => import('layers/transport/pages/HomePage/HomePage'), loading })
const PlanPage      = Loadable({ loader: () => import('layers/transport/pages/PlanPage/PlanPage'), loading })
const Plan2Page      = Loadable({ loader: () => import('layers/transport/pages/Plan2Page/Plan2Page'), loading })
const SchedulePage  = Loadable({ loader: () => import('layers/transport/pages/SchedulePage/SchedulePage'), loading })
// const ControlPage   = Loadable({ loader: () => import('layers/transport/pages/ControlPage/ControlPage'), loading })
const ConfigPage    = Loadable({ loader: () => import('layers/transport/pages/ConfigPage/ConfigPage'), loading })


export default (links) => (
  <Route component={LoadContainer}>
    <Route path={links.root} component={HomePage} />
    <Route path={links.plan} component={PlanPage} />
    <Route path={links.plan2} component={Plan2Page} />
    <Route path={links.schedule} component={SchedulePage} />
    {/*<Route path={links.control} component={ControlPage} />*/}
    <Route path={links.config} component={ConfigPage} />

    <Redirect path={`${links.root}/*`} to={links.root} />
  </Route>
)
